// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnDestroy, SimpleChange, SimpleChanges, Optional } from '@angular/core';

// --- RxJs
import { Observable, Subscription } from 'rxjs';

// --- 3rd Party
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { TermsAndConditionsModel } from '../../../models';
import { TermsAndConditionsBaseService } from '../../../core/services';

// #endregion

@Component({
  selector: 'hs-terms-and-conditions-modal',
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrls: ['./terms-and-conditions-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsAndConditionsModalComponent implements OnInit, OnDestroy {
  errorMessage$: Observable<string> = new Observable<string>();
  userAgreementRequiredMessage$: Observable<string> = new Observable<string>();
  isUpdating$: Observable<boolean> = new Observable<boolean>();
  termsAndConditionsAgreed: Observable<boolean> = new Observable<boolean>();
  showHasAcceptedTerms: Observable<boolean> = new Observable<boolean>();
  showEmailOptIn: Observable<boolean> = new Observable<boolean>();

  @Input() modal: NgbActiveModal | null = null;
  @Input() errorMessage: string = '';
  @Input() privacyLink: string = '';
  @Input() validationMessageUserAgreementRequired: string = '';
  @Input() hasAcceptedTerms: boolean = false;
  @Input() emailOptIn: boolean = false;
  @Input() agreementHeader: string = '';

  @Output() tacAccepted = new EventEmitter();
  @Output() sendAcceptance = new EventEmitter<TermsAndConditionsModel>();

  shouldShowTACFormSubscription: Subscription = Subscription.EMPTY;

  get activeModal(): NgbActiveModal | null {
    return this.modal ?? this.injectedModal ?? null;
  }

  constructor(
    private translate: TranslateService,
    private termsAndConditionsBaseService: TermsAndConditionsBaseService,
    @Optional() private injectedModal?: NgbActiveModal) { }

  ngOnInit(): void {
    this.errorMessage$ = this.termsAndConditionsBaseService.tacError$;
    this.isUpdating$ = this.termsAndConditionsBaseService.isUpdating$;
    this.showHasAcceptedTerms = this.termsAndConditionsBaseService.showHasAcceptedTerms$;
    this.showEmailOptIn = this.termsAndConditionsBaseService.showEmailOptIn$;

    // this.shouldShowTACFormSubscription = this.termsAndConditionsBaseService.shouldShowTACForm$.subscribe(shouldShow => {
    //   if (!shouldShow) {
    //     this.termsAndConditionsBaseService.clearState();
    //     this.activeModal.dismiss();
    //   }
    // });

    this.userAgreementRequiredMessage$ = this.translate
      .get('validationMessagePrivacyPolicyRequired');
  }

  ngOnDestroy(): void {
    if (this.shouldShowTACFormSubscription) {
      this.shouldShowTACFormSubscription.unsubscribe();
      this.shouldShowTACFormSubscription = Subscription.EMPTY;
    }
  }

  onCancel() {
    this.activeModal?.close('T&C Accepted');
    this.termsAndConditionsBaseService.hideTaCForm();
  }

  onUserTermsAndConditionsUpdated(model:TermsAndConditionsModel): void {
    this.termsAndConditionsBaseService.updateUserAgreementSelection(model);
  }

  onUserEmailOptInUpdated(model:TermsAndConditionsModel): void {
    this.termsAndConditionsBaseService.updateUserEmailOptInSelection(model);
  }
}
